import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gitlab-runner/builds/t3_BWwtJi/0/woongbee/homepage/front/src/app/homepage/company/[slug]/ClientRenderer.jsx");
